import { RootState } from '@/store/store'
import { type WS2ConversationTurnProgress } from './ws2.slice'

/**
 * Select: Conversation WebSocket Connected
 * Returns a boolean indicating if the conversation has an open WebSocket connection.
 */
export const selectConversationWebSocketConnected = (state: RootState, props: { conversationId: string }): boolean => {
  const connectionState = state.ws2State.connections[props.conversationId]
  return Boolean(connectionState?.connected)
}

export const selectConversationTurnProgress = (state: RootState, props: { conversationId: string }): WS2ConversationTurnProgress | null => {
  return state.ws2State.turnProgressByConversationId[props.conversationId] ?? null
}
